import classNames from "classnames";
import "./TextInput.scss";

interface Props {
  label: string;
  placeholder?: string;
  value: string;
  errorMessage: string | null;
  setValue: (newValue: string) => void;
  validate: () => boolean;
  textArea?: boolean;
  required?: boolean;
}

const TextInput: React.FC<Props> = ({
  label,
  placeholder,
  value,
  textArea,
  errorMessage,
  setValue,
  validate,
  required,
}: Props) => {
  return (
    <div className="text-input-norad">
      {/* biome-ignore lint/a11y/noLabelWithoutControl: It is being used by different components this is fine*/}
      <label className="text-input-norad__label-and-input">
        <span className="text-input-norad__label">
          {label}
          {required ? " *" : ""}
        </span>
        {textArea ? (
          <textarea
            className={classNames(
              "text-input-norad__input",
              "text-input-norad__input--textarea",
              { "text-input-norad__input--has-error": errorMessage }
            )}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={validate}
            placeholder={placeholder}
          />
        ) : (
          <input
            className={classNames("text-input-norad__input", {
              "text-input-norad__input--has-error": errorMessage,
            })}
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={validate}
            placeholder={placeholder}
          />
        )}
      </label>
      {errorMessage && (
        <p className="text-input-norad__error-message">{errorMessage}</p>
      )}
    </div>
  );
};

export default TextInput;
